import { useEffect, useState } from "react";
import { useStore } from "hooks/use-store";
import { GPS_POSITION_TIMEOUT_MS } from "utils/constants";

/**
 * GPS connection status derived from the "position" MQTT topic: connected
 * while position messages keep arriving, disconnected once none have been
 * received for GPS_POSITION_TIMEOUT_MS.
 */
export const useGpsStatus = (): boolean => {
  const lastPositionAt = useStore((state) => state.lastPositionAt);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (lastPositionAt === null) {
      setConnected(false);
      return;
    }

    const remaining = lastPositionAt + GPS_POSITION_TIMEOUT_MS - Date.now();

    if (remaining <= 0) {
      setConnected(false);
      return;
    }

    setConnected(true);
    const timeout = setTimeout(() => setConnected(false), remaining);
    return () => clearTimeout(timeout);
  }, [lastPositionAt]);

  return connected;
};
